var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.list.length != 0,
          expression: "list.length!=0"
        }
      ],
      staticClass: "aside-3"
    },
    [
      _c("dl", [
        _c("div", { staticClass: "title" }, [
          _c("i"),
          _vm._v(_vm._s(_vm.title))
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return !_vm.type
          ? _c("dd", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      item.open_type == 0 ? "/news/" + item.id : item.third_url,
                    target: "_blank",
                    alt: "..."
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: {
                          loading: _vm.lazyLoading,
                          error: _vm.lazyLoading,
                          src: item.img_url[0]
                        },
                        expression:
                          "{\n                loading: lazyLoading,\n                error: lazyLoading,\n                src: item.img_url[0]\n              }"
                      }
                    ],
                    attrs: {
                      "data-src": "/public/w/img/wap/loading.png",
                      alt: "..."
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.title))])
                ]
              )
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return _vm.type
          ? _c("dd", [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      item.open_type == 0 ? "/news/" + item.id : item.third_url,
                    target: "_blank",
                    alt: "..."
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: {
                          loading: _vm.lazyLoading,
                          error: _vm.lazyLoading,
                          src: item.img_url[0]
                        },
                        expression:
                          "{\n                    loading: lazyLoading,\n                    error: lazyLoading,\n                    src: item.img_url[0]\n                  }"
                      }
                    ],
                    attrs: {
                      "data-src": "/public/w/img/wap/loading.png",
                      alt: "..."
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.title))])
                ]
              )
            ])
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-510f4b21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-510f4b21","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-aside/img-aside.vue
// module id = null
// module chunks = 